import {
  Notification,
  MessageBox,
  Message
} from 'element-ui'

import router from '@/router'
import store from '@/store'
// 权限检查方法
export function hasPermission(data) {
  const buttonperms = localStorage.getItem('buttenpremissions')
  if (typeof data =='object' && data.constructor == Array) {
    return data.some(item => {
      return buttonperms.indexOf(item) > -1
    })
  } else {
    return buttonperms.indexOf(data) > -1
  }
}
export function jurisdiction(no) {
  if (!no) {
    // debugger
    Notification({
      title: '消息提示',
      type: 'error',
      message: '您没有此项权限！',
      position: 'bottom-right'
    })
  }
}
export function nobeforhandle(data) {
  let foo = true
  let massage = store.state.user.massage
  if (massage == '') {
    //all 代表不做权限限制
    if (data == 'all' || hasPermission(data)) {
    } else {
      foo = false
      jurisdiction()
    }
  }
  return foo
}
export function beforhandle(data, no) {
  // console.log(data);
  let foo = false
  let massage = store.state.user.massage
  // console.log(massage, 'massage');
  if (massage == '') {
    //all 代表不做权限限制
    if (data == 'all' || hasPermission(data)) {
      foo = true
    } else {
      jurisdiction(no)
    }
  } else if (massage == "未登录请前往登录") {
    Message.error(massage)
  } else if (massage == "您的企业信息正在审核中请耐心等待") {
    if (JSON.stringify(data).indexOf('userIndex') != -1) {
      foo = true
    } else {
      MessageBox.alert(massage, '', {
        confirmButtonText: '已知悉',
      });
    }
  } else if (massage == "请前往认证后操作") {
    if (JSON.stringify(data).indexOf('userIndex') != -1) {
      foo = true
    } else {
      MessageBox.confirm(massage, '提示', {
        confirmButtonText: '交易会员认证',
        cancelButtonText: '中长期会员认证',
        type: 'warning',
        customClass: 'hy-confirm',
        iconClass: 'el-icon-info',
        distinguishCancelAndClose: true
      }).then(() => {
        router.push('/authentication')
      }).catch(action => {
        // 仅点击"中长期会员认证"(cancel)时跳转，右上角关闭/ESC(close)不跳转
        if (action === 'cancel') {
          router.push('/MediumTerm')
        }
      });
    }
  }
  // console.log('ddd')
  return foo
}